module.exports = __webpack_public_path__ + "img/hgtv.02202f58.svg";